<template>
    <div>
        <div class="row" style="height: 100% !important; margin-right:0; margin-left:0;">
            <div class="col-md-6">
                <div class="upload-container">
                    <!-- h2>Upload Images</h2 -->
                    <div class="uploader-wrapper">


                        <photo-book-interior-image-uploader @photoBookImageUploaded="photoBookImageUploaded"
                            :remainingCount="remainingCount"></photo-book-interior-image-uploader>
                    </div>
                </div>

            </div>

            <div class="col-md-3 comments" v-if="showComments">

                <h2 class="card-title">Comments for image </h2>
                <comments :commentable_id="imageId" commentable_type="PhotoBookImage"></comments>

            </div>

            <div class="col-md-3 spreadss">
                <photo-book-interior-spread-list :imageReceived="imageReceived"
                    :loadedImage="loadedImage"></photo-book-interior-spread-list>


            </div>



        </div>
        <div class="row" style="margin: 30px;">
            <col-md-6>
                <button @click="toDasboard" class="btn btn-dark my-2">To Dashboard</button>
            </col-md-6>
            <col-md-6>
                <button @click="submitInterior" class="btn btn-dark my-2">I finished uploading</button>
            </col-md-6>
        </div>
    </div>
</template>

<script>
import Comment from '@/components/Feed/Comment';
import { mapGetters } from "vuex";
import { Modal, BaseAlert } from '@/components'
import Comments from '../Comments';
import swal from 'sweetalert2';
import PhotoBookInteriorSpreadList from './PhotoBookInteriorSpreadList.vue';
import PhotoBookInteriorImageUploader from './PhotoBookInteriorImageUploader.vue';

export default {
    name: "photo-book-interior-image-management",
    components: {
        Modal,
        BaseAlert,
        PhotoBookInteriorSpreadList,
        PhotoBookInteriorImageUploader,
        Comments,
    },
    props: {
        image: '',
        // minimum 128 pages so 60 spreads fillable
    },
    data() {
        return {
            loading: false,
            photo_book_images: [],
            imageId: 0,
            showComments: false,
            loadedImage: '',
            imageReceived: '',
            remainingCount: 120,
        };
    },
    methods: {

        toDasboard() {

            swal.fire({
                title: 'Well done!',
                text: "When you press Proceed you will be directed to the dashboard. Don't worry your images are saved in the art book project.",
                icon: 'info',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-dark',
                confirmButtonText: 'Proceed'
            }).then((result) => {
                if (result.value) {
                    this.$router.push({
                        name: 'Artist',
                        //name: "Dashboard",
                    });

                }
            })


        },
        photoBookImageUploaded(data) {
            console.log("received upload notification from uploader... activate comments and reload matching spread...");
            console.log("received data from uploader ---> ");
            console.log(data);
            this.imageId = data.image.id;
            this.showComments = true;

            this.imageReceived = true;

            this.loadedImage = data.image.id;
            // not neede but we still do it
            // this.$emit('photoBookImageUploaded', data);
            this.remainingCount -= 1;
        },
        submitInterior() {
            console.log("submitting interior..... finished uploading");
            this.loading = true;
            let query = {};
            this.$api.submitInterior(this.currentPhotoBook.id)
                .then((response) => {
                    console.log(response.data);
                })
                swal.fire({
                        title: 'Well done!',
                        text: "Our designer will get back to you with a draft layout. Stay tuned.",
                        icon: 'info',
                        buttonsStyling: false,
                        confirmButtonClass: 'btn btn-dark',
                        confirmButtonText: 'Proceed'
                    }).then((result) => {
                        if (result.value) {


                        }
                    })

                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false;
                    this.$router.push({
                                name: 'Artist',
                            });
                });
        },
        retrievePhotoBookInteriorImages() {
            console.log("the one image");
            console.log(this.image);
            console.log("the one image");
            return this.$image_host + "/" + this.image.image.medium.url;
            this.loading = true;
            let query = {};
            query["imgid"] = this.image.id;
            this.$api.getPhotoBookImage(this.image.imageable_id, this.image.id)
                .then((response) => {
                    this.photo_book_image = response.data;
                    console.log(this.photo_book_image);
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false;
                    return 'http://0.0.0.0:8000/' + this.photo_book_image.image.medium.url;
                });
        },
    },
    computed: {
        ...mapGetters({
            currentAccount: 'currentAccount',
            currentPhotoBookImages: 'currentPhotoBookImages',
            currentPhotoBook: 'currentPhotoBook'
        }),
    },
    mounted() {
        console.log(this.image);
    },
};
</script>
<style scoped>
/* Struktur */
.dasgrosseganze {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 70vh;
    width: 100vw;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
}

.photo_book_page_list_group {}

.spreadss {
    overflow-x: hidden;
    overflow-y: scroll;
    z-index: 20;
    width: 250px;
    position: absolute;
    right: 20px;
    top: 90px;
    bottom: -30px;
}

.spreads {
    position: absolute;
    left: 0px;
    bottom: 0px;
    top: 0px;
    width: 500px;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 1rem;
    z-index: 20;
    background: #FFF;
    /*
	border-radius: 1rem;
	box-shadow: 0 0 2rem 0 rgba(136,152,170,.15);
	*/
}

.spreads img {
    margin-bottom: 1rem;
    max-width: 100%;
    height: auto;
    border: 1px solid #eee;
}

.spreads_img {
    position: absolute;
    left: 70px;
    right: 0px;
    bottom: 0px;
    overflow-x: auto;
    overflow-y: auto;
    /*
    height: 150px;
    */
    height: auto;

    padding-right: 70px;
    /*
    padding: 1rem;
	*/
    z-index: 20;
    background: #FFF;
    /*
	border-radius: 1rem;
	box-shadow: 0 0 2rem 0 rgba(136,152,170,.15);
	*/
}

.sidebar_img img {
    margin-bottom: 1rem;
    max-width: 100%;
    height: auto;
    border: 1px solid #eee;
}

.photo_book_image_list_group {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    padding-left: 0;
    margin-bottom: 0;
}

.toolbar {
    position: absolute;
    right: 0px;
    bottom: 0px;
    top: 70px;
    width: 200px;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 1rem;
    z-index: 20;
    background: #FFF;

    /*
	border-radius: 1rem;
	box-shadow: 0 0 2rem 0 rgba(136,152,170,.15);
	*/
}

.toolbar img {
    margin-bottom: 1rem;
    max-width: 100%;
    height: auto;
    border: 1px solid #eee;
}



.docviewwrapper {
    position: fixed;
    /*
    left: 304px;
	right: 150px;
	*/
    left: 200px;
    right: 200px;
    bottom: 1rem;
    top: 0px;
    /*
	right: 1rem;
	*/
}

.photo_book_page_list_group_item {
    width: 100%;
    max-width: 250px;
}

.photo_book_page_list_item {
    width: 100%;
    display: flex;
    justify-content: center;
}

.photo_book_page_list_item img {
    width: 100%;
    height: auto;
    object-fit: contain;
}

/* Add styles for the left column container */
.upload-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-right: 20px;
}

/* Add styles for the uploader */
.uploader-wrapper {
    flex: 1;
    margin: 10px;
    /* Add space between heading and uploader */
    padding: 20px;
}

.comments {
    flex: 1;
    margin: 10px;
    /* Add space between heading and uploader */
    padding: 20px;
}
</style>